import React from 'react';
import PropTypes from 'prop-types';
import FormCheckboxContainer from '../../../redux/containers/FormCheckboxContainer';
import './TermsAndConditions.scss';
import Constants from '../../../common/Configuration.json';

const TermsAndConditions = props =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <h3 className="half-charcoal">Terms & Conditions</h3>
          <div className="row">
            <div className="col-xs-12">
              <FormCheckboxContainer
                id="receiveUpdates"
                name="receiveUpdates"
                autotestClass="autotest-receiveUpdates"
              >
                I want to receive updates & offers from Skinny
              </FormCheckboxContainer>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <FormCheckboxContainer
                id="acceptTerms"
                name="acceptTerms"
                autotestClass="autotest-accepTerms"
              >
                I have read and accept the&nbsp;
                <a href="https://skinny.co.nz/terms" target="_blank" rel="noopener noreferrer">
                  Skinny terms and conditions
                </a>
                {props.term !== Constants.openTermDescriptor &&
                <span>
                  <br />
                  If I have chosen the {props.term} contract option and cancel before my contract is up, I understand
                  that
                  I will be charged
                  <a href="https://www.skinny.co.nz/skinny-terms/#UBB" target="_blank" rel="noopener noreferrer"> an
                  early termination fee</a> of ${props.isByoModemSelected ? props.byoFirstTerminationFee : props.firstTerminationFee} if I leave between months 1 - 6,
                  or ${props.isByoModemSelected ? props.byoSecondTerminationFee : props.secondTerminationFee} if I leave between months 7 - 12.
                </span>
                }
              </FormCheckboxContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
;

TermsAndConditions.propTypes = {
  term: PropTypes.string.isRequired,
  firstTerminationFee: PropTypes.number.isRequired,
  secondTerminationFee: PropTypes.number.isRequired,
  byoFirstTerminationFee: PropTypes.number.isRequired,
  byoSecondTerminationFee: PropTypes.number.isRequired,
  isByoModemSelected: PropTypes.bool,
};

export default TermsAndConditions;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/TermsAndConditions/TermsAndConditions.js
 **/